import { render } from "./YourOrders.vue?vue&type=template&id=29f047de"
import script from "./YourOrders.vue?vue&type=script&lang=js"
export * from "./YourOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__